import { View } from "@-/com.npmjs.react-native";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { type AdminControl, useAdminControls } from "@-/dev.improve.haniverse.lib.admin.controls";
import { Fragment } from "react";
import { AdminPanelButton, AdminPanelSection } from "#admin-panel-section";

/** The shared admin controls (also in Settings › Admin › Controls and the Rozenite dev menu). */
export function AdminPanelControlsSection() {
  const { bundle, controls } = useAdminControls();
  return (
    <AdminPanelSection description={`JavaScript bundle: ${bundle}`} title="Deck & data">
      {controls.map((control, index) => (
        <Fragment key={control.id}>
          {index > 0 ? <View className="h-px bg-border" /> : null}
          <AdminPanelControlRow control={control} />
        </Fragment>
      ))}
    </AdminPanelSection>
  );
}

function AdminPanelControlRow({ control }: { control: AdminControl }) {
  return (
    <View className="flex-row items-center justify-between gap-3">
      <View className="flex-1 gap-0.5">
        <Text className="text-sm font-semibold text-foreground">{control.title}</Text>
        <Text className="text-xs text-muted-foreground" numberOfLines={2}>
          {control.status}
        </Text>
      </View>
      <AdminPanelButton
        disabled={control.disabled}
        onPress={() => {
          control.run();
        }}
        title={control.actionLabel}
      />
    </View>
  );
}
